import { Component, Inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { HomeController } from '@shared/src/controllers/home/home.controller';
import { QRCodeController } from '@shared/src/controllers/qrcode/qrcode.controller';
import { FileUpDownLoadDto } from '@shared/src/dtos/base/FileUpDownLoadDto';
import { RouteCMRQrDto } from '@shared/src/dtos/route/cmr/qr/RouteCMRQrDto';
import { HString } from '@shared/src/public-api';

@Component({
  selector: 'shared-ecmrs-qr-component',
  templateUrl: './shared.ecmrs.qr.component.html',
  styleUrls: ['./shared.ecmrs.qr.component.scss'],
})
export class SharedECMRsQRComponent {

  constructor(private qRCodeController: QRCodeController,
    @Inject('HomeController') protected homeController: HomeController,
    protected router: Router) {
    if (homeController.useIonic) this.useIonic = homeController.useIonic();
  };

  public useIonic: boolean = false;

  @Input()
  public helpResource: string; 
  
  @Input()
  public qrdownload: boolean; 
  
  private _uuidQR: string;
  @Input()
  public set uuidQR(value: string) {
      if (this._uuidQR === value)
          return;
      this._uuidQR = value;
      this.loadQR();
  }
  public get uuidQR(): string {
      return this._uuidQR;
  }

  ngOnInit() {

  }

  onClickQR(){
    if (!HString.isNullOrNullString(this.uuidQR)){
        this.homeController.routeToExternalECMRsUUID(this.uuidQR);
    }
  }

  public filedto: FileUpDownLoadDto;
  public formatDocumentQRCode: string;
  loadQR() {
    if (!HString.isNullOrNullString(this.uuidQR)) {
        if(!this.qrdownload){
            this.qRCodeController.getQRCodeECMRsByUUID(this.uuidQR).subscribe(data => { 
                this.welcomeQr(data);
            });
        }else{
            this.qRCodeController.getQRCodeECMRsFileDownloadByUUID(this.uuidQR).subscribe(data => { 
                this.welcomeQr(data);
            });
        }
    }
  }
  
  welcomeQr(data: RouteCMRQrDto){
        if(data == null){
            this.filedto = null;
        }else
            this.filedto = data.qr;
        if(this.filedto != null && this.filedto.fileBytes != null)
            this.formatDocumentQRCode = 'data:image/' + this.filedto.fileType + ';base64,' + this.filedto.fileBytes;
  }
}
